export default {
  de: {
    any: "Egal",
    apply: "Übernehmen",
    choose: 'Bitte wählen',
    close: 'Schließen',
    config: 'Konfiguration',
    contact: {
      phone: 'Telefon',
      email: 'Email'
    },
    creator: 'Ersteller',
    connected: 'Verbunden',
    combine: 'Kombinieren',
    complete: 'Abschließen',
    disconnected: 'Nicht verbunden',
    discardChanges: 'Änderungen verwerfen',
    discardChangesMessage: 'Wollen Sie die Änderungen wirklich verwerfen',
    reconnecting: 'Verbindungsaufbau',
    cancel: 'Abbrechen',
    save: 'Speichern',
    wantSave: 'wollen Sie die Änderungen speichern?',
    wantDelete: 'wollen Sie den Datensatz löschen?',
    wantMultiDelete: 'Wollen Sie die ausgewählten Daten löschen?',
    back: 'Zurück',
    add: 'Hinzufügen',
    from: 'Von',
    to: 'Bis',
    comment: 'Kommentar',
    commentOn: 'Kommentieren',
    name: 'Name',
    description: 'Beschreibung',
    error: 'Fehler',
    keys: 'Tasten',
    notice: 'Notiz',
    multipleError: 'Mehrere Fehler sind aufgetreten',
    edit: 'Bearbeiten',
    editor: 'Bearbeiter',
    date: "Datum",
    delete: 'Löschen',
    details: 'Details',
    deleteQuest: 'wirklich löschen?',
    cancelQuest: 'wirklich stornieren?',
    infos: 'Informationen',
    address: 'Anschrift',
    deleteItem: ' löschen?',
    number: 'Nummer',
    active: 'Aktiv',
    help: 'Hilfe',
    copy: 'Kopieren',
    asGrid: 'Als Grid anzeigen',
    asTable: 'Als Tabelle anzeigen',
    type: 'Type',
    sum: 'Summe',
    split: 'Trennen',
    search: 'Suche',
    noData: 'Keine Daten verfügbar',
    noMatter: 'Egal',
    reload: 'Neu laden',
    modifier: 'Bearbeiter',
    summary: 'Summe',
    print: 'Drucken',
    printPreview: 'Druckvorschau',
    saveGridState: 'Tabelleneinstellungen speichern',
    title: 'Titel',
    timeStamp: 'Zeitpunkt',
    upload: 'Hochladen',
    view: "Anzeigen",
    text: 'Text',
    state: "Status",
    size: "Größe",
    days: {
      any: 'Egal',
      monday: "Mo",
      tuesday: "Di",
      wednesday: "Mi",
      thursday: "Do",
      friday: "Fr",
      saturday: 'Sa',
      sunday: 'So'
    },
    notifications: {
      savedGridState: {
        type: 'success',
        message: 'Tabelleneinstellungen erfolgreich gespeichert',
        title: 'Erfolgreich gespeichert'
      }
    }
  }
}
